module.exports = __webpack_public_path__ + "static/img/GA.e0605818.svg";